<template>

<v-dialog v-model="dialog" width="500">
  
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="my-vicon">settings</v-icon>
        </template>

    <v-card>
          
          <!--<component :is="dynamicComponent"></component>-->
          <settingsCharts />
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
                
      </v-dialog>

</template>



<script>
import settingsCharts from "@/components/Chart/modalSettings";
//import settingsPoolTimeline from "../PoolTimeline/modalSettings";

export default {
    components: {
      settingsCharts
    },
    props: ["type"], 
    data(){
        return{
            dialog: false,
        }
    },
    computed: {
      /*
    dynamicComponent() {
      if(this.type == 0){
        return "settingsCharts"
      }else{
        var selected = this.$store.state.userInfo.submenus.init[this.type]
        var init = this.$store.state.userInfo.submenus.data[this.type][selected]
        return `settings${this.$store.state.componentMap[init].component}`
      }
    },
    */
    
  },

}

</script>

<style scoped>

.my-vicon {
  color: #808f9c;
  font-size: 18px;
  margin-bottom: 5px;
}
.my-vicon:hover {
  color: #ffffff;
}

</style>
